const useExtrasCategoriesLogic = () => {
  const apiRoute = "addOnCategories";
  const onlyForm = undefined;

  const initFields = [
    {
      name: "name",
      label: "Extras Category Name",
      type: "text",
      isRequired: true,
      err: "Extras Category Name is required",
    },
    // Add more fields as needed
  ];

  //Roles
  const admin = process.env.REACT_APP_ADMIN_ROLE;
  const financeRole = process.env.REACT_APP_FINANCE_ROLE;
  const managerRole = process.env.REACT_APP_MANAGER_ROLE;
  ///Add,Delete,Edit Roles
  const addRoles = [admin, financeRole, managerRole];
  const deleteRoles = [admin, financeRole, managerRole];
  const editRoles = [admin, financeRole, managerRole];

  const getPromises = (temp) => {
    return [];
  };
  return {
    apiRoute,
    addRoles,
    editRoles,
    deleteRoles,
    initFields,
    getPromises,
    onlyForm,
  };
};

export default useExtrasCategoriesLogic;
